import {
    ALLOWED_FILE_TYPES_FOR_FINANCIAL_ACCOUNTS,
    ALLOWED_FILE_TYPES_FOR_LIMITED_UNIVERSAL_IMPORT,
    ALLOWED_FILE_TYPES_FOR_UNIVERSAL_IMPORT,
} from "../../common/constants";
import { useTypedFlags } from "../../hooks/useTypedFlags";

export interface ImportConfig {
    allowedFileTypes: string[];
    modalTitle: string;
    showTransactionsCount: boolean;
    uploadText: string;
}

export const useImportConfig = (type: "universal" | "manual"): ImportConfig => {
    const { importerLimitFileTypes } = useTypedFlags();

    if (type === "universal") {
        return {
            allowedFileTypes: importerLimitFileTypes
                ? ALLOWED_FILE_TYPES_FOR_LIMITED_UNIVERSAL_IMPORT
                : ALLOWED_FILE_TYPES_FOR_UNIVERSAL_IMPORT,
            modalTitle: "Import Bank Statements",
            showTransactionsCount: false,
            uploadText: importerLimitFileTypes
                ? "Drop in CSVs, PDFs, or Images"
                : "Drop in CSVs, PDFs, Excel, or Images",
        };
    }

    return {
        allowedFileTypes: ALLOWED_FILE_TYPES_FOR_FINANCIAL_ACCOUNTS,
        modalTitle: "CSV import account",
        showTransactionsCount: true,
        uploadText: "Upload or drag and drop your CSVs",
    };
};
